import { render, staticRenderFns } from "./GeneralInfo.html?vue&type=template&id=7d5c816b&external"
import script from "./GeneralInfo.ts?vue&type=script&lang=ts&external"
export * from "./GeneralInfo.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports